import classNames from 'classnames';
import React from 'react';
import Button from '@alfa-retail-react/components/button';
import Modal from '@alfa-retail-react/components/modal';
import Link from '@alfa-retail-react/components/link';

import { WEB_VISOR_DISABLE, WEB_VISOR_HIDE } from 'app/utils/AnalyticsUtils';
import { CardOrder } from 'app/model/CardOrder';
import { FieldSet } from 'app/component/fieldset/FieldSet';
import { Reference } from 'app/model/Reference';
import { FormatUtils } from 'app/utils/FormatUtils';
import { useIsDesktop } from 'app/utils/useWindowType';

export interface IdentityDocumentModalProps {
    order: CardOrder;

    documentType: Reference;

    residencyCountryReference: Reference;

    citizenshipCountryReference: Reference;
}

export const IdentityDocumentModal = ({
    order,
    ...props
}: IdentityDocumentModalProps) => {
    const [open, setOpen] = React.useState(false);
    const handleModalOpen = () => setOpen(!open);

    const [isDesktop] = useIsDesktop();
    return (
        <>
            <Link
                pseudo
                className={classNames('identityTrigger', WEB_VISOR_HIDE)}
                view={'primary'}
                onClick={handleModalOpen}
            >
                {props.documentType.name}, {order.client.identity.series}
                {order.client.identity.number}
            </Link>
            <Modal
                isDesktop={isDesktop}
                className="documentTypeModal"
                title={props.documentType.name}
                open={open}
                onClose={handleModalOpen}
                content={
                    <FieldSet
                        className={'identityFieldSet'}
                        fieldsProps={[
                            {
                                className: 'residency',
                                title: 'Резидентство',
                                value: (
                                    <span
                                        className={classNames(
                                            'countryName',
                                            WEB_VISOR_HIDE,
                                        )}
                                    >
                                        {props.residencyCountryReference.name.toLowerCase()}
                                    </span>
                                ),
                            },
                            {
                                className: 'citizenship',
                                title: 'Гражданство',
                                value: (
                                    <span
                                        className={classNames(
                                            'countryName',
                                            WEB_VISOR_HIDE,
                                        )}
                                    >
                                        {props.citizenshipCountryReference.name.toLowerCase()}
                                    </span>
                                ),
                            },
                            {
                                className: 'number',
                                title: 'Серия и номер',
                                value: (
                                    <span className={WEB_VISOR_HIDE}>
                                        {order.client.identity.series}
                                        {order.client.identity.number}
                                    </span>
                                ),
                            },
                            {
                                className: 'validity',
                                title: 'Дата выдачи и срок действия',
                                value: (
                                    <span
                                        className={WEB_VISOR_HIDE}
                                    >{`${order.client.identity.issueDate.format(
                                        FormatUtils.DEFAULT_DATE_FORMAT,
                                    )} - 
                                ${order.client.identity.expirationDate.format(
                                    FormatUtils.DEFAULT_DATE_FORMAT,
                                )}`}</span>
                                ),
                            },
                            {
                                className: 'issuerCode',
                                title: 'Орган, выдавший документ',
                                value: (
                                    <span className={WEB_VISOR_HIDE}>
                                        {order.client.identity.issuerName}
                                    </span>
                                ),
                            },
                        ]}
                    />
                }
                actionButton={
                    <Button
                        className="confirm"
                        view="accent"
                        size="s"
                        onClick={handleModalOpen}
                        block
                    >
                        Понятно
                    </Button>
                }
            />
        </>
    );
};
